import React from 'react';
import '../Css/Skills.css';
import { FaChartLine, FaLightbulb } from 'react-icons/fa';
import { BiCodeAlt, BiNetworkChart, BiCog } from 'react-icons/bi';
import { GiBrain } from 'react-icons/gi';

export default function Skills() {
  return (
    <section id='skills'>
      <span className='skillTitle'>What I Do</span>
      <span className='skillDesc'>
        Results-driven Full-Stack Software Developer with proven experience delivering production-ready web applications using Vue.js, React, Laravel, Flask, and PostgreSQL.
      </span>

      <div className='skillBars'>
        <div className='skillBar'>
          <div className='skillBarIcon'>
            <BiCodeAlt className='icon' />
            <BiNetworkChart className='icon overlapping' />
          </div>
          <div className='skillBarText'>
            <h2>Full-Stack Development</h2>
            <p>
              Core Stack: Vue.js, React, TypeScript, JavaScript, Python, Laravel, Flask, PostgreSQL, REST APIs. I build responsive user interfaces and robust backend services, from enterprise customer engagement platforms to property management systems.
            </p>
          </div>
        </div>
        
        <div className='skillBar'>
          <div className='skillBarIcon'>
            <FaChartLine className='icon' />
            <BiCog className='icon overlapping' />
          </div>
          <div className='skillBarText'>
            <h2>Frontend & Backend Integration</h2>
            <p>
              Proficient in Vue.js, React, Next.js, HTML, CSS, Tailwind CSS for frontend and Flask, Laravel, Node.js for backend. Experienced in PostgreSQL, MySQL, SQLite, and API integration with deployment on Render.
            </p>
          </div>
        </div>
        
        <div className='skillBar'>
          <div className='skillBarIcon'>
            <GiBrain className='icon' />
            <FaLightbulb className='icon overlapping' />
          </div>
          <div className='skillBarText'>
            <h2>Tools & Practices</h2>
            <p>
              Git, GitHub, Bitbucket, API Integration, Deployment (Render), Debugging & Testing, Agile Development. Skilled in JavaScript (ES6+), TypeScript, Python, PHP, Java, and Kotlin.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}